import WithRender from "../../templates/base/preview3D.html";

import { mapGetters, mapActions } from "vuex";

export default WithRender({
  computed: {
    ...mapGetters(["getPreview3D", "get3DPreviewId"])
  },
  methods: {
    ...mapActions(["setPreview3DLoading"]),
    onLoad: function () {
      setTimeout(() => {
        this.setPreview3DLoading(false);
      }, 1000);
    }
  },
  props: ["visible"]
});
